import { Header, Content } from '.';

const ViewHistory = () => (
  <div className="flex flex-col sm:h-70vh">
    <Header />
    <Content />
  </div>
);

export default ViewHistory;
